import React from 'react';
import { motion } from 'framer-motion';
const SHOPIFY_CHECKOUT_URL = 'https://simpleymejor.com/cart/46654273749169:1';
function buildCheckoutUrl(base: string): string {
  const params = new URLSearchParams(window.location.search);
  const allowedParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];
  const url = new URL(base);
  allowedParams.forEach(param => {
    const value = params.get(param);
    if (value) url.searchParams.set(param, value);
  });
  return url.toString();
}
interface CTAButtonProps {
  onClick?: () => void;
  href?: string;
  children?: React.ReactNode;
  className?: string;
}
export function CTAButton({
  onClick,
  href = SHOPIFY_CHECKOUT_URL,
  children,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout');
    }
    if (onClick) {
      onClick();
    } else {
      setTimeout(() => {
        window.location.href = buildCheckoutUrl(href);
      }, 150);
    }
  };
  return <motion.button onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`bg-[#C8A870] hover:bg-[#E8D5B0] text-[#0a0807] px-8 min-h-[56px] md:min-h-0 md:px-12 md:py-5 rounded-[3px] font-body font-semibold uppercase tracking-[0.1em] text-[15px] md:text-[16px] shadow-[0_10px_30px_rgba(0,0,0,0.45)] hover:shadow-[0_0_40px_rgba(200,168,112,0.18),0_14px_40px_rgba(0,0,0,0.5)] transition-all duration-300 w-full md:w-auto text-center ${className}`} data-id="element-32">
      {children || 'Acceder al Protocolo'}
    </motion.button>;
}